"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var RotatingBoxesLoader_1 = __importDefault(require("./rotatingBoxes/RotatingBoxesLoader"));
exports.RotatingBoxesLoader = RotatingBoxesLoader_1.default;
var AlternatingOrbitsLoader_1 = __importDefault(require("./alternatingOrbits/AlternatingOrbitsLoader"));
exports.AlternatingOrbitsLoader = AlternatingOrbitsLoader_1.default;
var SpinningCircleLoader_1 = __importDefault(require("./spinningCircle/SpinningCircleLoader"));
exports.SpinningCircleLoader = SpinningCircleLoader_1.default;
var SpinningOrbitLoader_1 = __importDefault(require("./spinningOrbit/SpinningOrbitLoader"));
exports.SpinningOrbitLoader = SpinningOrbitLoader_1.default;
var PulseBubbleLoader_1 = __importDefault(require("./pulseBubble/PulseBubbleLoader"));
exports.PulseBubbleLoader = PulseBubbleLoader_1.default;
var BouncyBallsLoader_1 = __importDefault(require("./bouncyBalls/BouncyBallsLoader"));
exports.BouncyBallsLoader = BouncyBallsLoader_1.default;
var DyingLightLoader_1 = __importDefault(require("./dyingLight/DyingLightLoader"));
exports.DyingLightLoader = DyingLightLoader_1.default;
var CirclePopLoader_1 = __importDefault(require("./circlePop/CirclePopLoader"));
exports.CirclePopLoader = CirclePopLoader_1.default;
var GooeyCircleLoader_1 = __importDefault(require("./gooeyCircle/GooeyCircleLoader"));
exports.GooeyCircleLoader = GooeyCircleLoader_1.default;
var LiquidLoader_1 = __importDefault(require("./liquid/LiquidLoader"));
exports.LiquidLoader = LiquidLoader_1.default;
var BlurrySquareLoader_1 = __importDefault(require("./blurrySquare/BlurrySquareLoader"));
exports.BlurrySquareLoader = BlurrySquareLoader_1.default;
var JellyBounceLoader_1 = __importDefault(require("./jellyBounce/JellyBounceLoader"));
exports.JellyBounceLoader = JellyBounceLoader_1.default;
var AtomLoader_1 = __importDefault(require("./atom/AtomLoader"));
exports.AtomLoader = AtomLoader_1.default;
var ElasticCircleLoader_1 = __importDefault(require("./elasticCircle/ElasticCircleLoader"));
exports.ElasticCircleLoader = ElasticCircleLoader_1.default;
var FlipLoader_1 = __importDefault(require("./flip/FlipLoader"));
exports.FlipLoader = FlipLoader_1.default;
var MovingSquareLoader_1 = __importDefault(require("./movingSquare/MovingSquareLoader"));
exports.MovingSquareLoader = MovingSquareLoader_1.default;
var FlippingCubeLoader_1 = __importDefault(require("./flippingCube/FlippingCubeLoader"));
exports.FlippingCubeLoader = FlippingCubeLoader_1.default;
var SlidingCubeLoader_1 = __importDefault(require("./slidingCube/SlidingCubeLoader"));
exports.SlidingCubeLoader = SlidingCubeLoader_1.default;
var SwingingCubeLoader_1 = __importDefault(require("./swingingCube/SwingingCubeLoader"));
exports.SwingingCubeLoader = SwingingCubeLoader_1.default;
var SwitchingCubeLoader_1 = __importDefault(require("./switchingCube/SwitchingCubeLoader"));
exports.SwitchingCubeLoader = SwitchingCubeLoader_1.default;
var LinneardLoader_1 = __importDefault(require("./linneard/LinneardLoader"));
exports.LinneardLoader = LinneardLoader_1.default;
var FillCircleLoader_1 = __importDefault(require("./fillCircle/FillCircleLoader"));
exports.FillCircleLoader = FillCircleLoader_1.default;
var GooeyLoader1_1 = __importDefault(require("./gooey1/GooeyLoader1"));
exports.GooeyLoader1 = GooeyLoader1_1.default;
var GooeyLoader2_1 = __importDefault(require("./gooey2/GooeyLoader2"));
exports.GooeyLoader2 = GooeyLoader2_1.default;
var HelixLoader_1 = __importDefault(require("./helix/HelixLoader"));
exports.HelixLoader = HelixLoader_1.default;
var VolumeLoader_1 = __importDefault(require("./volume/VolumeLoader"));
exports.VolumeLoader = VolumeLoader_1.default;
var VortexLoader_1 = __importDefault(require("./vortex/VortexLoader"));
exports.VortexLoader = VortexLoader_1.default;
var SlicesLoader_1 = __importDefault(require("./slices/SlicesLoader"));
exports.SlicesLoader = SlicesLoader_1.default;
var SphereLoader_1 = __importDefault(require("./sphere/SphereLoader"));
exports.SphereLoader = SphereLoader_1.default;
var BarsLoader_1 = __importDefault(require("./bars/BarsLoader"));
exports.BarsLoader = BarsLoader_1.default;
var ClockLoader_1 = __importDefault(require("./clock/ClockLoader"));
exports.ClockLoader = ClockLoader_1.default;
var WaveLoader_1 = __importDefault(require("./wave/WaveLoader"));
exports.WaveLoader = WaveLoader_1.default;
var TextureLoader_1 = __importDefault(require("./texture/TextureLoader"));
exports.TextureLoader = TextureLoader_1.default;
var BatteryLoader_1 = __importDefault(require("./battery/BatteryLoader"));
exports.BatteryLoader = BatteryLoader_1.default;
var HydrogenLoader_1 = __importDefault(require("./hydrogen/HydrogenLoader"));
exports.HydrogenLoader = HydrogenLoader_1.default;
var FillSquareLoader_1 = __importDefault(require("./fillSquare/FillSquareLoader"));
exports.FillSquareLoader = FillSquareLoader_1.default;
var HypnosisLoader_1 = __importDefault(require("./hypnosis/HypnosisLoader"));
exports.HypnosisLoader = HypnosisLoader_1.default;
var LineLoader_1 = __importDefault(require("./line/LineLoader"));
exports.LineLoader = LineLoader_1.default;
var CircleFadeLoader_1 = __importDefault(require("./circleFade/CircleFadeLoader"));
exports.CircleFadeLoader = CircleFadeLoader_1.default;
var EightBitLoader_1 = __importDefault(require("./eightBit/EightBitLoader"));
exports.EightBitLoader = EightBitLoader_1.default;
var PingPongLoader_1 = __importDefault(require("./pingPong/PingPongLoader"));
exports.PingPongLoader = PingPongLoader_1.default;
var KissyBallsLoader_1 = __importDefault(require("./kissyBalls/KissyBallsLoader"));
exports.KissyBallsLoader = KissyBallsLoader_1.default;
var DrawWaveLoader_1 = __importDefault(require("./drawWave/DrawWaveLoader"));
exports.DrawWaveLoader = DrawWaveLoader_1.default;
var BlobLoader_1 = __importDefault(require("./blob/BlobLoader"));
exports.BlobLoader = BlobLoader_1.default;
var BarsLoader2_1 = __importDefault(require("./bars2/BarsLoader2"));
exports.BarsLoader2 = BarsLoader2_1.default;
var RotatingCircleLoader_1 = __importDefault(require("./rotatingCircle/RotatingCircleLoader"));
exports.RotatingCircleLoader = RotatingCircleLoader_1.default;
var NotepadLoader_1 = __importDefault(require("./notepad/NotepadLoader"));
exports.NotepadLoader = NotepadLoader_1.default;
var DoubleSquareLoader_1 = __importDefault(require("./doubleSquare/DoubleSquareLoader"));
exports.DoubleSquareLoader = DoubleSquareLoader_1.default;
var BrokenCirclesLoader_1 = __importDefault(require("./brokenCircles/BrokenCirclesLoader"));
exports.BrokenCirclesLoader = BrokenCirclesLoader_1.default;
var PipLoader_1 = __importDefault(require("./pip/PipLoader"));
exports.PipLoader = PipLoader_1.default;
var DotsLoader_1 = __importDefault(require("./dots/DotsLoader"));
exports.DotsLoader = DotsLoader_1.default;
